(function () {
  if (window.__bfoureStatInit) return;
  window.__bfoureStatInit = true;

  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 2200;
  var START_DELAY = 300;

  function parse(text) {
    if (text == null) return null;
    var match = String(text).match(/^([^\d.\-]*)(\-?[\d.,]+)(.*)$/);
    if (!match) return null;
    var raw = match[2].replace(/,/g, '');
    var num = parseFloat(raw);
    if (isNaN(num)) return null;
    var dot = raw.indexOf('.');
    var decimals = dot >= 0 ? raw.length - dot - 1 : 0;
    return { prefix: match[1], suffix: match[3], target: num, decimals: decimals };
  }

  function format(value, decimals) {
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function animate(el, p) {
    setTimeout(function () {
      var start = null;
      function step(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / DURATION, 1);
        var eased = 1 - Math.pow(1 - t, 4);
        el.textContent = p.prefix + format(p.target * eased, p.decimals) + p.suffix;
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, START_DELAY);
  }

  var observer = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          var p = parse(entry.target.getAttribute('data-stat-value'));
          if (p) animate(entry.target, p);
        }
      }, { threshold: 0.6, rootMargin: '0px 0px -20% 0px' })
    : null;

  function init(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-stat-value]:not([data-stat-init])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-stat-init', '1');
      var p = parse(el.getAttribute('data-stat-value'));
      if (!p || REDUCED_MOTION) continue;
      el.textContent = p.prefix + format(0, p.decimals) + p.suffix;
      if (observer) observer.observe(el);
      else animate(el, p);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.querySelector('[data-stat-value]');
    if (!el) return;
    var p = parse(el.getAttribute('data-stat-value'));
    if (p) animate(el, p);
  });
})();
